import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import doctorService from "../../services/doctorService";

export const fetchDoctors = createAsyncThunk(
  "doctors/fetchDoctors",
  async () => {
    return await doctorService.getDoctors();
  },
);

export const fetchDoctorById = createAsyncThunk(
  "doctors/fetchDoctorById",
  async (id) => {
    return await doctorService.getDoctorById(id);
  },
);

export const addDoctor = createAsyncThunk(
  "doctors/addDoctor",
  async (doctorData) => {
    return await doctorService.createDoctor(doctorData);
  },
);

export const updateDoctorData = createAsyncThunk(
  "doctors/updateDoctorData",
  async ({ id, doctorData }) => {
    return await doctorService.updateDoctor(id, doctorData);
  },
);

export const removeDoctor = createAsyncThunk(
  "doctors/removeDoctor",
  async (id) => {
    await doctorService.deleteDoctor(id);
    return id;
  },
);

const doctorSlice = createSlice({
  name: "doctors",
  initialState: {
    doctors: [],
    selectedDoctor: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSelectedDoctor: (state) => {
      state.selectedDoctor = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDoctors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.loading = false;
        state.doctors = action.payload;
      })
      .addCase(fetchDoctors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addDoctor.fulfilled, (state, action) => {
        state.doctors.push(action.payload);
      })
      .addCase(removeDoctor.fulfilled, (state, action) => {
        state.doctors = state.doctors.filter(
          (d) => d.doctor_id !== action.payload,
        );
      });
  },
});

export const { clearSelectedDoctor } = doctorSlice.actions;
export default doctorSlice.reducer;
